import { ApiUtility } from "./ApiUtility";
export interface IVideos {
    executionTime: number
    result: IVideosResult
    status: boolean
    message: any
    errors: any
}

export interface IVideosResult {
    slug: string
    name: string
    id: string
    author: string
    isFavourite: boolean
    lyricsHash: any
    videoLength: string
    description: string
    videoPath: any
    videoUrl: string
    videoHash: any
    lyricsPath: string
}
class VideoService {
    route = "/posts";
    categoryRoute = "/api/settings/filters?lang=";
    pravachanfav = "/api/pravachans/";
    pravachanwithid = "/api/Pravachans/";
    categoryvideos = "api/Videos";
    videoo = "/api/Videos/";
    useractivity = "/api/"; // Audios/useractivity/useractivity"
    allvideos = "/api/Videos?lang=";
    videodetailRoute = "/api/Videos/";
    categories = "/api/Videos/Category";
    mbcategories = "/api/videos/categories";
    getPravachanFilters = (productFor: string) => {
        return ApiUtility.get(
            this.categoryRoute +
            localStorage.getItem("lan") +
            "&productFor=" +
            productFor
        );
    };

    getFilters = (lang?: any, productFor?: string) => {
        return ApiUtility.get(
            this.categoryRoute +
            localStorage.getItem("lan") +
            "&productFor=" +
            productFor
        );
    };

    addPravachanFavourite = (id: string) => {
        return ApiUtility.post(this.pravachanfav + id + "/favourite", {});
    };

    removePravachanFaviourite = (id: string) => {
        return ApiUtility.delete(this.pravachanfav + id + "/favourite");
    };

    getCategoryWiseVideos(id?: string) {
        const endpoint = id
            ? `${this.categoryvideos}/Categories?id=${id}&lang=${localStorage.getItem("lan")}`
            : `${this.categoryvideos}/Categories?lang=${localStorage.getItem("lan")}`;

        return ApiUtility.get(endpoint, {
            userActivity: 1,
        });
    }

    getAllVideoss = (
        search: string,
        start: number,
        length: number,
        categoryId: string,
        isChildLiterature: boolean,
        sort: string,
        authorId: string,
        VideoLanguages: string,
        isSpecial: boolean,
        subjectId: string
    ) => {
        return ApiUtility.get(
            this.allvideos +
            localStorage.getItem("lan") +
            "&search=" +
            search +
            "&start=" +
            start +
            "&length=" +
            length +
            "categoryId=" +
            categoryId +
            "&isChildLiterature=" +
            isChildLiterature +
            "&sort=" +
            sort +
            "&authorId=" +
            authorId +
            "&VideoLanguage=" +
            VideoLanguages +
            "&isSpecial=" +
            isSpecial +
            "&subjectId=" +
            subjectId
        )
    }

    getAllVideos(
        categoryId?: string,
        authorId?: string,
        sort?: any,
        length?: any,
        start?: number
    ) {
        const lang = localStorage.getItem("lan");
        const startIndex = start || 0;
        let endpoint = `${this.categoryvideos}?start=${startIndex}&length=${length}&isChildLiterature=false&isSpecial=false`;

        if (categoryId) {
            endpoint += `&categoryId=${categoryId}`;
        }
        if (authorId) {
            endpoint += `&authorId=${authorId}`;
        }

        endpoint += `&lang=${lang}`;

        return ApiUtility.get(endpoint, {
            userActivity: 1,
            sort,
        });
    }

    addFavourite = (id: string) =>
        ApiUtility.post(`/api/Videos/${id}/favourite`, {});

    removeFavourite = (id: string) =>
        ApiUtility.delete(`/api/Videos/${id}/favourite`);

    getSpecificVideo(videoId: any) {
        let endpoint = `/api/Videos/${videoId}`;
        if (typeof videoId === "string" && videoId.startsWith("slug-")) {
            endpoint = `/api/Videos/${encodeURIComponent(videoId)}`;
        }
        return ApiUtility.get(endpoint);
    }
        getVideoDetails = (id: string) => {
            const lang = localStorage.getItem("lan") || "hindi";
            return ApiUtility.get(`${this.videodetailRoute}${id}/SEO?lang=${lang}`);
        };

        getCategories = (lang?: string, authors?: any) => {
            let url = this.categories;
            if (lang) {
                url += `?lang=${lang}`;
            }
            if (authors) {
                url += `?authors=${authors}`;
            }
            return ApiUtility.get(url);
        };

        getMbCategories = (lang?: string, authors?: any, id?: string) => {
            let url = this.mbcategories;
            if (lang) {
                url += `?lang=${lang}`;
            }
            if (authors) {
                url += `?authors=${authors}`;
            }
            if (id) {
                url += `&id=${id}`;
            }
            return ApiUtility.get(url);
        };

    updateUserActivity(product: string, productId: string, time: string) {
        return ApiUtility.post(
            this.useractivity + product + "/" + productId + "/useractivity",
            {
                activityMedium: 1,
                time: time,
            }
        );
    }

    GetCategoryDataById(idOrSlug: string) {
        const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
        const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
        return ApiUtility.get(
            `/api/Videos/Categories/${identifier}?lang=` + localStorage.getItem("lan")
        );
    }

    GetAuthorDataById(idOrSlug: string) {
        const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
        const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
        return ApiUtility.get(
            `/api/Videos/Authors/${identifier}?lang=` + localStorage.getItem("lan")
        );
    }
}
export default new VideoService();
